import { Helmet } from 'react-helmet';

import Category from '../components/Detail/Category';
import Body from '../components/Detail/Body';
import Recommend from '../components/Detail/Recommend';

import { products } from '../resource/Products';

function Detail(props) {
  const {
    match: {
      params: { id },
    },
    location: { state },
  } = props;
  const product = products.find((product) => product.id === id);

  return (
    <div className="detail__container border-top">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {product.name} - 라이프스팬 - 관절 건강을 위한 자연 영양제
        </title>
      </Helmet>
      <div className="detail__wrapper">
        <Category state={state} name={product.name} />
        <Body product={product} />
        <Recommend items={product.related} />
      </div>
    </div>
  );
}

export default Detail;
